import React, {FC} from 'react';

import {
  AnalyticsHeatMapMetricsEnum,
  AnalyticsTableMetricsEnum,
} from '../../../../models/api/analyticsMetricsModel';
import {
  AnalyticsReportsEnum,
  BasicReportProps,
  ReportElementIdsEnum,
} from '../../../helpers/analyticsReportHelpers';
import {ReportHeatMap} from '../../reportElements/heatmap/reportHeatMap';
import {ReportHeroCards} from '../../reportElements/heroCards/reportHeroCards';
import {ReportTable} from '../../reportElements/table/reportTable';
import {teamColumnId} from '../../reportElements/table/tableHelpers';

/*
 * Constants.
 */

// @TODO: implement this in the metric parser.
const defaultTeammatesTableColumnIds = [
  'num_messages_sent',
  'avg_reply_time',
  'avg_first_reply_time',
  'avg_handle_time',
  'num_archived_segments',
];

const blockedColumnIds = ['avg_csat_survey_score', teamColumnId];

const teammatesTableInitialState = {
  sortBy: [
    {
      id: 'num_messages_sent',
      desc: true,
    },
  ],
};

/*
 * Props.
 */

interface TeamPerformanceReportProps extends BasicReportProps {
  hasCsatSurveysFeature: boolean;
}

/*
 * Component.
 */

export const TeamPerformanceReport: FC<TeamPerformanceReportProps> = ({isLoading, hasCsatSurveysFeature}) => {
  const disabledColumnIds = hasCsatSurveysFeature ? [] : ['csat_survey_satisfaction'];

  return (
    <>
      {/* Metrics Cards */}
      <ReportHeroCards
        reportType={AnalyticsReportsEnum.TEAM_PERF}
        reportSectionId={ReportElementIdsEnum.TEAM_METRICS_CARDS}
        isLoading={isLoading}
      />

      {/* Busiest times Heatmap */}
      <ReportHeatMap
        reportSectionId={ReportElementIdsEnum.TEAM_HEATMAP}
        isLoading={isLoading}
        metric={AnalyticsHeatMapMetricsEnum.INBOX}
      />

      {/* Teammates Table */}
      <ReportTable
        reportSectionId={ReportElementIdsEnum.TEAM_TEAMMATES_TABLE}
        isLoading={isLoading}
        metric={AnalyticsTableMetricsEnum.TEAM_PERFORMANCE}
        defaultColumnIds={defaultTeammatesTableColumnIds}
        blockedColumnIds={blockedColumnIds}
        disabledColumnIds={disabledColumnIds}
        disableSelection
        initialState={teammatesTableInitialState}
      />
    </>
  );
};
